// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TP1M","newExpiryDate":"styles_newExpiryDate__2RC47","footer":"styles_footer__1hdGc"};